"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.create$isUserActive = create$isUserActive;
var StatefulObservable_1 = require("../tools/StatefulObservable");
var subscribeToUserInteraction_1 = require("../tools/subscribeToUserInteraction");
var tsafe_1 = require("../vendor/frontend/tsafe");
var workerTimers_1 = require("../tools/workerTimers");
var GLOBAL_CONTEXT_KEY = "__oidc-spa.createIsUserActive.globalContext";
(_a = window[GLOBAL_CONTEXT_KEY]) !== null && _a !== void 0 ? _a : (window[GLOBAL_CONTEXT_KEY] = {
    appInstanceId: Math.random().toString(36).slice(2)
});
var globalContext = window[GLOBAL_CONTEXT_KEY];
function create$isUserActive(params) {
    var configId = params.configId, sessionId = params.sessionId;
    var _a = (function () {
        var channelName = "oidc-spa:user-interaction-tracker:".concat(sessionId !== null && sessionId !== void 0 ? sessionId : configId);
        function notifyOtherTabsOfUserInteraction() {
            new BroadcastChannel(channelName).postMessage((0, tsafe_1.id)({
                appInstanceId: globalContext.appInstanceId
            }));
        }
        function subscribeToUserInteractionOnOtherTabs(callback) {
            var channel = new BroadcastChannel(channelName);
            channel.onmessage = function (_a) {
                var message = _a.data;
                (0, tsafe_1.assert)((0, tsafe_1.is)(message));
                if (message.appInstanceId === globalContext.appInstanceId) {
                    return;
                }
                callback();
            };
        }
        return { notifyOtherTabsOfUserInteraction: notifyOtherTabsOfUserInteraction, subscribeToUserInteractionOnOtherTabs: subscribeToUserInteractionOnOtherTabs };
    })(), notifyOtherTabsOfUserInteraction = _a.notifyOtherTabsOfUserInteraction, subscribeToUserInteractionOnOtherTabs = _a.subscribeToUserInteractionOnOtherTabs;
    var $isUserActive = (0, StatefulObservable_1.createStatefulObservable)(function () { return true; });
    var scheduleSetInactive = function () {
        var timer = (0, workerTimers_1.setTimeout)(function () {
            (0, tsafe_1.assert)($isUserActive.current);
            $isUserActive.current = false;
        }, 5000);
        return function () {
            (0, workerTimers_1.clearTimeout)(timer);
            clearScheduledSetInactive = undefined;
        };
    };
    var clearScheduledSetInactive = scheduleSetInactive();
    var onUserActivity = function (params) {
        var isInteractionOnCurrentTab = params.isInteractionOnCurrentTab;
        clearScheduledSetInactive === null || clearScheduledSetInactive === void 0 ? void 0 : clearScheduledSetInactive();
        clearScheduledSetInactive = scheduleSetInactive();
        if (isInteractionOnCurrentTab) {
            notifyOtherTabsOfUserInteraction();
        }
        if (!$isUserActive.current) {
            $isUserActive.current = true;
        }
    };
    (0, subscribeToUserInteraction_1.subscribeToUserInteraction)({
        throttleMs: 1000,
        callback: function () { return onUserActivity({ isInteractionOnCurrentTab: true }); }
    });
    subscribeToUserInteractionOnOtherTabs(function () { return onUserActivity({ isInteractionOnCurrentTab: false }); });
    return $isUserActive;
}
//# sourceMappingURL=isUserActive.js.map